var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPSearchLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.875C5.72411 0.876505 4.50091 1.38402 3.59872 2.28621C2.69652 3.1884 2.18901 4.41161 2.18751 5.6875C2.18598 6.73016 2.52656 7.74453 3.15701 8.575C3.15701 8.575 3.28826 8.74781 3.30969 8.77275L7 13.125L10.6921 8.77056C10.7113 8.74738 10.843 8.575 10.843 8.575L10.8434 8.57369C11.4736 7.74358 11.814 6.72968 11.8125 5.6875C11.811 4.41161 11.3035 3.1884 10.4013 2.28621C9.4991 1.38402 8.2759 0.876505 7 0.875ZM7 7.4375C6.65389 7.4375 6.31554 7.33486 6.02776 7.14257C5.73997 6.95028 5.51567 6.67697 5.38322 6.3572C5.25076 6.03743 5.21611 5.68556 5.28363 5.34609C5.35115 5.00663 5.51783 4.6948 5.76257 4.45006C6.00731 4.20532 6.31913 4.03865 6.6586 3.97113C6.99806 3.9036 7.34993 3.93826 7.6697 4.07071C7.98947 4.20316 8.26278 4.42747 8.45508 4.71525C8.64737 5.00304 8.75 5.34138 8.75 5.6875C8.74943 6.15145 8.56487 6.59623 8.2368 6.9243C7.90874 7.25236 7.46396 7.43692 7 7.4375Z",
    fill: "#4E26A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPSearchLocation);
export default __webpack_public_path__ + "static/media/p_search_location.8a63981c5b99e6e0cc2830622bc3f071.svg";
export { ForwardRef as ReactComponent };